import axiosInstance from "./axiosInstance";

export const getAllContacts = async () => {
  try {
    const response = await axiosInstance.get("/contact", {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch contacts");
  }
};

export const getContactById = async (id) => {
  try {
    const response = await axiosInstance.get(`/contact/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch contact");
  }
};

export const createContact = async (formData) => {
  try {
    const response = await axiosInstance.post("/public/contact", formData, {
      headers: {
        "Content-Type": "application/json",
        authType: "PreLogin",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to create contact");
  }
};

export const deleteContact = async (id) => {
  try {
    const response = await axiosInstance.delete(`/contact-delete/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to delete contact");
  }
};